<div class="flex w-full justify-end gap-4 items-center">
  <sbnb-button
    *ngIf="property.counts?.airbnb > 0"
    matTooltip="Fetch the latest data from Airbnb for your linked fields."
    size="mini"
    type="secondary"
    [label]="resyncing ? 'Resyncing...' : 'Resync...'"
    (clicked)="resync()"
    [disabled]="resyncing"></sbnb-button>
  <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
</div>

<sbnb-helptext-wrapper area="content" pageId="property-details"></sbnb-helptext-wrapper>

<div class="rule__section-container noborder">
  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.public_name"
      label="Public name"
      [value]="property.public_name"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      (updated)="property.public_name = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>
</div>

<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable" id="tags">
      <span>Tags</span>
    </h3>
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px grid">
    <div *ngFor="let tag of property.tags" [matTooltip]="property.muted ? 'Unavailable for muted properties.' : ''">
      <div
        class="properties__tags"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="4px"
        [class.pointer-events]="property.muted">
        <sbnb-icon [size]="16" icon="tag" class="shrink-0 text-night-lighter"></sbnb-icon>
        <span>{{ tag }}</span>
        <span class="properties__tags-close" (click)="removeTag(tag)">x</span>
      </div>
    </div>

    <div [matTooltip]="property.muted ? 'Unavailable for muted properties.' : ''">
      <button
        *ngIf="!addTagBool"
        [class.pointer-events]="property.muted"
        mat-flat-button
        class="addtag__button button__text button__small"
        (click)="toggleAddTag()">
        + Add tag
      </button>
    </div>

    <div *ngIf="addTagBool" fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-form-field class="input__mini rule__edit-title">
        <input
          (keyup.enter)="newTagElm.value && newTagElm.value.length > 0 ? addTag(newTagElm.value) : null"
          #newTagElm
          [formControl]="newTag"
          matInput
          [matAutocomplete]="auto"
          placeholder="Tag name..." />

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option
            *ngFor="let option of filteredAccountPropertyTags | async"
            [value]="option"
            (click)="addTag(option.tag)">
            {{ option.tag }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <button
        [disabled]="!newTagElm.value || !newTagElm.value.length > 0"
        class="button__small"
        mat-flat-button
        matSuffix
        aria-label="save"
        (click)="addTag(newTagElm.value)">
        Save
      </button>
      <button
        mat-flat-button
        class="button__small button__secondary rule__edit-close-btn"
        matSuffix
        aria-label="cancel"
        (click)="addTagBool = false">
        Cancel
      </button>
    </div>
  </div>
</div>

<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable" id="photos">
      <span fxFlex>Photos</span>

      <sbnb-button *ngIf="!photosEdit" size="mini" label="Edit" type="text" (click)="photosEdit = true"></sbnb-button>

      <sbnb-property-update-status
        *ngIf="!photosEdit"
        [edited]="property.edited?.photos"
        [hasAirbnbListing]="property.counts?.airbnb > 0"></sbnb-property-update-status>
    </h3>
  </div>

  <p class="text__small">
    Drag and drop images to change their order on your Direct sites. Use tags to control specific site placements. Not
    all our site templates support all tags.
  </p>

  <sbnb-image-gallery
    [propertyId]="property.id"
    [images]="property.photos"
    [editMode]="photosEdit"
    [tags]="propertyPhotoTags | async"
    (editsMade)="property.edited.photos = true"
    (editModeChanged)="photosEdit = $event"></sbnb-image-gallery>

  <div fxLayout fxLayoutAlign="start center" *ngIf="photosEdit">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable">
      <span fxFlex>&nbsp;</span>

      <sbnb-button *ngIf="photosEdit" size="mini" label="Done" type="text" (click)="photosEdit = false"></sbnb-button>

      <sbnb-property-update-status
        [edited]="property.edited?.photos"
        [hasAirbnbListing]="property.counts?.airbnb > 0"></sbnb-property-update-status>
    </h3>
  </div>
</div>

<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable" id="basics">
      <span>Basics</span>
    </h3>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.summary"
      label="Summary"
      [value]="property.summary"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.summary = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.description"
      label="Description"
      [value]="property.description"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.description = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.space"
      label="Space overview"
      [value]="property.space"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.space = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.access"
      label="Guest access"
      [value]="property.access"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.access = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.house_manual"
      label="House manual"
      placeholder="Helpful tips about how things work at your property."
      [value]="property.house_manual"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.house_manual = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.notes"
      label="Other details to note"
      placeholder="Additional details to share with guests before they book."
      [value]="property.notes"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.notes = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-number-edit
      label="Max number of guests"
      key="person_capacity"
      [edited]="property.edited?.person_capacity"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.person_capacity"
      (updated)="property.person_capacity = $event; updateProperty()"></sbnb-property-detail-number-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-language-selection
      [edited]="property.edited?.languages"
      [languages]="property.languages"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.languages = $event; updateProperty()"></sbnb-property-detail-language-selection>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.wifi_name"
      label="Wifi name"
      [value]="property.wifi_name"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.wifi_name = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.wifi_password"
      label="Wifi password"
      [value]="property.wifi_password"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.wifi_password = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-amenity-selection
      [edited]="property.edited?.amenities"
      [amenities]="property.amenities"
      [availableAmenities]="availableAmenities"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.amenities = $event; updateProperty()"></sbnb-property-detail-amenity-selection>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-shortcodes [propertyId]="property.id"></sbnb-property-detail-shortcodes>
  </div>
</div>

<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable" id="location">
      <span>House Rules</span>
    </h3>
  </div>
  <div class="detail-subitem border-b-smoke border-b md:border-none">
    <sbnb-property-detail-number-edit-boolean-edit
      label="Pets allowed"
      [edited]="property.edited?.allow_pets"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.allow_pets"
      (updated)="property.allow_pets = $event; updateProperty()"></sbnb-property-detail-number-edit-boolean-edit>
  </div>
  <div class="detail-subitem border-b-smoke border-b md:border-none">
    <sbnb-property-detail-number-edit-boolean-edit
      label="Smoking allowed"
      [edited]="property.edited?.allow_smoking"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.allow_smoking"
      (updated)="property.allow_smoking = $event; updateProperty()"></sbnb-property-detail-number-edit-boolean-edit>
  </div>

  <div class="detail-subitem border-b-smoke border-b md:border-none">
    <sbnb-property-detail-number-edit-boolean-edit
      label="Events allowed"
      [edited]="property.edited?.allow_events"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.allow_events"
      (updated)="property.allow_events = $event; updateProperty()"></sbnb-property-detail-number-edit-boolean-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.house_rules"
      label="Additional rules"
      [value]="property.house_rules"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      (updated)="property.house_rules = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>
</div>

<div class="rule__section-container" *ngIf="hasCheckoutTasksFeature">
  <div fxLayout fxLayoutAlign="space-between center">
    <h3 fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable">
      <span>Guest Checkout Tasks</span>
    </h3>
    <div *ngIf="!checkoutTasksEdit">
      <sbnb-button size="mini" label="Edit" type="text" (clicked)="checkoutTasksEditMode()"></sbnb-button>
    </div>
  </div>

  <!-- Tasks List View -->
  <div *ngIf="!checkoutTasksEdit">
    <div class="detail-subitem" *ngFor="let task of displayedCheckoutTasks">
      <div class="font-medium mb-1">{{ getTaskDisplayName(task.type) }}</div>
      <div class="text-sm text-night" *ngIf="task.task_detail">{{ task.task_detail }}</div>
    </div>

    <div *ngIf="!displayedCheckoutTasks.length" class="text-sm text-night-lighter">No checkout tasks added yet</div>
  </div>

  <!-- Tasks Edit View -->
  <div *ngIf="checkoutTasksEdit">
    <div class="detail-subitem mb-2" *ngFor="let task of editedCheckoutTasks">
      <div class="flex justify-between items-center gap-4">
        <div class="flex-grow">
          <div class="font-medium mb-2">{{ getTaskDisplayName(task.type) }}</div>
          <div>
            <textarea
              class="w-full p-2 border rounded outline-none"
              [ngClass]="{
                'border-red-500 focus:border-red-500':
                  task.type === 'ADDITIONAL_REQUESTS' && (!task.task_detail || !task.task_detail.trim()),
                'border-smoke focus:border-smoke': !(
                  task.type === 'ADDITIONAL_REQUESTS' &&
                  (!task.task_detail || !task.task_detail.trim())
                )
              }"
              [maxlength]="getTaskMaxLength(task.type)"
              [(ngModel)]="task.task_detail"
              (ngModelChange)="onTaskDetailChange()"
              [placeholder]="
                task.type === 'ADDITIONAL_REQUESTS' ? 'Add task details...' : 'Add optional task details...'
              "
              rows="2"></textarea>
            <div class="flex justify-between text-xs">
              <div *ngIf="task.type === 'ADDITIONAL_REQUESTS' && !task.task_detail" class="text-red">
                Details required for Additional Requests
              </div>
              <div class="text-night-lighter">
                {{ task.task_detail?.length || 0 }}/{{ getTaskMaxLength(task.type) }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex-shrink-0 cursor-pointer mt-6" (click)="removeCheckoutTask(task.type)">
          <sbnb-icon icon="trash" [size]="20" class="text-smoke-darker hover:text-red"></sbnb-icon>
        </div>
      </div>
    </div>

    <!-- Add New Task Button and Menu -->
    <div class="mt-4 relative">
      <div (click)="$event.stopPropagation()">
        <sbnb-button
          size="mini"
          type="text"
          label="+ New Task"
          class="font-medium text-green hover:text-green-darker"
          (clicked)="toggleNewTaskMenu()"
          [disabled]="availableCheckoutTasks.length === 0"></sbnb-button>
      </div>

      <!-- New Task Options Menu -->
      <div
        *ngIf="showNewTaskForm"
        class="absolute left-0 top-full mt-1 z-10 bg-white rounded border border-smoke p-2 shadow-md min-w-[200px]"
        (click)="$event.stopPropagation()"
        (clickOutside)="showNewTaskForm = false">
        <div
          *ngFor="let task of availableCheckoutTasks"
          class="p-2 hover:bg-smoke-lighter rounded cursor-pointer"
          (click)="startNewTask(task)">
          {{ task.label }}
        </div>
      </div>
    </div>

    <!-- New Task Form (at the top) -->
    <div class="detail-subitem" *ngIf="newTaskType">
      <div class="flex justify-between items-center gap-4">
        <div class="flex-grow">
          <div class="font-medium mb-2">{{ getTaskDisplayName(newTaskType) }}</div>
          <div>
            <textarea
              class="w-full p-2 border border-smoke rounded"
              maxlength="{{ getTaskMaxLength(newTaskType) }}"
              [(ngModel)]="newTaskDetail"
              placeholder="Add optional task details..."
              rows="2"></textarea>
            <div class="text-xs text-night-lighter text-right">
              {{ newTaskDetail?.length || 0 }}/{{ getTaskMaxLength(newTaskType) }}
            </div>
          </div>
        </div>
        <div class="flex-shrink-0 cursor-pointer mt-6" (click)="cancelNewTask()">
          <sbnb-icon icon="trash" [size]="20" class="text-smoke-darker hover:text-red"></sbnb-icon>
        </div>
      </div>
    </div>

    <!-- Edit Mode Actions -->
    <div class="mt-8" fxLayout fxLayoutAlign="end center" fxLayoutGap="8px">
      <sbnb-button size="mini" type="text" label="Cancel" (clicked)="cancelCheckoutTasksEdit()"></sbnb-button>
      <sbnb-button
        size="mini"
        type="primary"
        label="Save"
        [disabled]="isSaveDisabled"
        (clicked)="saveCheckoutTasks()"></sbnb-button>
    </div>
  </div>
</div>

<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable" id="location">
      <span>Location</span>
    </h3>
  </div>

  <div class="detail-subitem">
    <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
      <strong fxFlex>Address</strong>
      <sbnb-property-update-status
        [edited]="property.edited?.address"
        [hasAirbnbListing]="property.counts?.airbnb > 0"
        [hasBookingListing]="property.counts?.booking_managed > 0"></sbnb-property-update-status>
    </div>
    <span class="night text__small">{{ property.address || 'Unknown' }}</span>
  </div>

  <!-- <div class="detail-subitem" *ngIf="property.lat && property.lng">
    <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
      <strong fxFlex>Map</strong>
    </div>
    <google-map
      [options]="mapOptions"
      [center]="{ lat: property.lat, lng: property.lng }"
      height="200px"
      width="100%"
      class="gmap"
    >
      <map-marker
        [position]="{ lat: property.lat, lng: property.lng }"
      ></map-marker>
    </google-map>
  </div> -->

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.neighborhood_overview"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      label="Neighborhood description"
      [value]="property.neighborhood_overview"
      (updated)="property.neighborhood_overview = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>

  <div class="detail-subitem">
    <sbnb-property-detail-description-edit
      [edited]="property.edited?.transit"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      label="Getting around"
      [value]="property.transit"
      (updated)="property.transit = $event; updateProperty()"></sbnb-property-detail-description-edit>
  </div>
</div>

<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable" id="features-rooms">
      <span>Property and rooms</span>
    </h3>
  </div>

  <div fxLayoutAlign="start center">
    <strong fxFlex>Rooms and features</strong>
    <sbnb-button *ngIf="!roomsEdit" size="mini" label="Edit" type="text" (click)="roomsEdit = true"></sbnb-button>

    <sbnb-button *ngIf="roomsEdit" size="mini" label="Done" type="text" (click)="roomsEdit = false"></sbnb-button>
  </div>

  <div *ngIf="roomsEdit === false" class="rooms-summary">
    <span *ngIf="property.bedrooms">Bedrooms: {{ property.bedrooms }}</span>
    <span *ngIf="property.beds">Beds: {{ property.beds }}</span>
    <span *ngIf="property.bathrooms">Bathrooms: {{ property.bathrooms }}</span>
    <span *ngIf="property.kitchens">Kitchens: {{ property.kitchens }}</span>
    <span *ngIf="property.living_rooms">Living rooms: {{ property.living_rooms }}</span>
    <span *ngIf="property.offices">Offices: {{ property.offices }}</span>
    <span *ngIf="property.gardens">Gardens: {{ property.gardens }}</span>
    <span *ngIf="property.patios">Patios: {{ property.patios }}</span>
    <span *ngIf="property.pools">Pools: {{ property.pools }}</span>
    <span *ngIf="property.hot_tubs">Hot tubs: {{ property.hot_tubs }}</span>
    <span *ngIf="property.garages">Garages: {{ property.garages }}</span>
    <span *ngIf="property.gyms">Gyms: {{ property.gyms }}</span>
  </div>

  <div
    *ngIf="roomsEdit === true"
    class="detail-subitem detail-subitem-grid"
    fxLayout="row wrap"
    fxLayoutAlign="start center"
    fxLayoutGap="60px">
    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Bedrooms"
      key="bedrooms"
      [edited]="property.edited?.bedrooms"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.bedrooms"
      (updated)="property.bedrooms = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Beds"
      key="beds"
      [edited]="property.edited?.beds"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.beds"
      (updated)="property.beds = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Bathrooms"
      key="bathrooms"
      [edited]="property.edited?.bathrooms"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.bathrooms"
      [allowDecimals]="true"
      (updated)="property.bathrooms = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Kitchens"
      key="kitchens"
      [edited]="property.edited?.kitchens"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.kitchens"
      (updated)="property.kitchens = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Living rooms"
      key="living_rooms"
      [edited]="property.edited?.living_rooms"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.living_rooms"
      (updated)="property.living_rooms = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Offices"
      key="offices"
      [edited]="property.edited?.offices"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [value]="property.offices"
      (updated)="property.offices = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Gardens"
      key="gardens"
      [edited]="property.edited?.gardens"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [value]="property.gardens"
      (updated)="property.gardens = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Patios"
      key="patios"
      [edited]="property.edited?.patios"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [value]="property.patios"
      (updated)="property.patios = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Pools"
      key="pools"
      [edited]="property.edited?.pools"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.pools"
      (updated)="property.pools = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Hot tubs"
      key="hot_tubs"
      [edited]="property.edited?.hot_tubs"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.hot_tubs"
      (updated)="property.hot_tubs = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Garages"
      key="garages"
      [edited]="property.edited?.garages"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [value]="property.garages"
      (updated)="property.garages = $event; updateProperty()"></sbnb-property-detail-number-edit>

    <sbnb-property-detail-number-edit
      fxFlex="0 0 auto"
      label="Gyms"
      key="gyms"
      [edited]="property.edited?.gyms"
      [hasAirbnbListing]="property.counts?.airbnb > 0"
      [hasBookingListing]="property.counts?.booking_managed > 0"
      [value]="property.gyms"
      (updated)="property.gyms = $event; updateProperty()"></sbnb-property-detail-number-edit>
  </div>

  <div class="detail-subitem">
    <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
      <strong fxFlex>Property type</strong>
      <sbnb-property-update-status
        [edited]="property.edited?.property_type"
        [hasAirbnbListing]="property.counts?.airbnb > 0"
        [hasBookingListing]="property.counts?.booking_managed > 0"></sbnb-property-update-status>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="8px">
      <span class="night text__small">
        {{ property.types[0] || 'Unknown' }}
        {{ property.property_type ? ' - ' + property.property_type : null }}
      </span>
    </div>
  </div>

  <div class="detail-subitem" [hidden]="property.room_type == null">
    <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
      <strong fxFlex>Room type</strong>
      <sbnb-property-update-status
        [edited]="property.edited?.room_type"
        [hasAirbnbListing]="property.counts?.airbnb > 0"></sbnb-property-update-status>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="8px">
      <span class="night text__small">
        {{ property.room_type }}
      </span>
    </div>
  </div>

  <div class="detail-subitem">
    <div>
      <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
        <strong fxFlex>Check-in time</strong>
        <sbnb-property-update-status
          [edited]="property.edited?.check_in_time"
          [hasAirbnbListing]="property.counts?.airbnb > 0"
          [hasBookingListing]="property.counts?.booking_managed > 0"></sbnb-property-update-status>
      </div>
      <sbnb-time-picker
        [hours]="check_in_hours"
        [minutes]="check_in_minutes"
        (closed)="checkInOutTimesChanged($event, 'check_in_')"></sbnb-time-picker>
    </div>
  </div>

  <div class="detail-subitem">
    <div>
      <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
        <strong fxFlex>Check-out time</strong>
        <sbnb-property-update-status
          [edited]="property.edited?.check_out_time"
          [hasAirbnbListing]="property.counts?.airbnb > 0"
          [hasBookingListing]="property.counts?.booking_managed > 0"></sbnb-property-update-status>
      </div>
      <sbnb-time-picker
        [hours]="check_out_hours"
        [minutes]="check_out_minutes"
        (closed)="checkInOutTimesChanged($event, 'check_out_')"></sbnb-time-picker>
    </div>
  </div>

  <!-- <div class="detail-subitem">
    <div>
      <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
        <strong fxFlex>Security deposit</strong>
        <sbnb-property-update-status
          [edited]="property.edited?.checkin"
          [hasAirbnbListing]="property.counts?.airbnb > 0"
        ></sbnb-property-update-status>
      </div>
      <span class="night text__small">{{ property.checkin || 'Not set' }}</span>
    </div>
  </div> -->
</div>

<div class="rule__section-container">
  <div fxLayout fxLayoutAlign="start center">
    <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable" id="features-rooms">
      <span>Other</span>
    </h3>
  </div>
  <div class="detail-subitem">
    <div fxLayout fxLayoutAlign="start center" class="detail-subheader">
      <strong fxFlex>Property uuid</strong>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="8px">
      <span class="night text__small">
        {{ property.uuid }}
      </span>
    </div>
  </div>
</div>

<!-- Mobile legend for update icons -->
<div fxHide fxShow.lt-md style="margin-top: 32px">
  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
    <sbnb-icon-airbnb [size]="12"></sbnb-icon-airbnb>
    <span>This field periodically refreshes data from Airbnb.</span>
  </div>

  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
    <sbnb-icon-airbnb [size]="12" [muted]="true"></sbnb-icon-airbnb>
    <span>This field does not refresh data from Airbnb.</span>
  </div>

  <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
    <svg
      matTooltip="This data is pushed to any Direct sites linked to your account."
      width="14"
      height="14"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="18" height="18" rx="4" fill="#ED3C6A" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.989 11.6926C11.1368 11.6926 12.878 9.97053 12.878 7.84628C12.878 5.72204 11.1368 4 8.989 4C6.84115 4 5.09998 5.72204 5.09998 7.84628C5.09998 9.97053 6.84115 11.6926 8.989 11.6926ZM8.98891 10.1542C10.2776 10.1542 11.3223 9.12097 11.3223 7.84643C11.3223 6.57188 10.2776 5.53866 8.98891 5.53866C7.70021 5.53866 6.6555 6.57188 6.6555 7.84643C6.6555 9.12097 7.70021 10.1542 8.98891 10.1542ZM7.42473 12.4614C6.99988 12.4614 6.65547 12.8058 6.65547 13.2306C6.65547 13.6555 6.99988 13.9999 7.42473 13.9999H10.553C10.9779 13.9999 11.3223 13.6555 11.3223 13.2306C11.3223 12.8058 10.9779 12.4614 10.553 12.4614H7.42473Z"
        fill="white" />
    </svg>
    <span>This field pushes any updates to any Direct Sites.</span>
  </div>
</div>

<div fxLayoutAlign="end center">
  <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
</div>
